import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
const tiers = [{
  name: '银卡会员',
  price: 'SGD 500',
  period: '/年',
  description: '开启尊贵体验的入门之选',
  features: ['查看所有伴游基础资料', '每月3次优先预约权', '基础客服支持', '定期活动邀请'],
  highlight: false,
  cta: '申请加入'
}, {
  name: '金卡会员',
  price: 'SGD 2,000',
  period: '/年',
  description: '尊享优先特权与专属服务',
  features: ['查看所有伴游详细资料', '无限次优先预约权', '24/7 专属客服经理', '私人定制约会方案', '免审核快速通道'],
  highlight: true,
  cta: '立即升级'
}, {
  name: '铂金会员',
  price: 'SGD 5,000',
  period: '/年',
  description: '极致奢华的顶级身份象征',
  features: ['包含金卡所有权益', '独家顶级伴游预约权', '全球商务伴游安排', '高端私人派对入场券', '神秘生日礼遇', '匿名支付通道'],
  highlight: false,
  cta: '联系顾问'
}];
export function MembershipSection() {
  return <section className="py-24 bg-dark-surface relative overflow-hidden" data-id="element-222">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-223" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-224">
        <div className="text-center mb-16" data-id="element-225">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-5xl text-white mb-4" data-id="element-226">
            会员专属
          </motion.h2>
          <p className="text-gray-400" data-id="element-227">
            加入 SGLonelyGuy 会员俱乐部，开启您的非凡之旅
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-stretch" data-id="element-228">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative flex flex-col p-8 rounded-2xl border ${tier.highlight ? 'bg-dark-card border-gold-500 shadow-[0_0_30px_rgba(212,175,55,0.15)] transform md:-translate-y-4' : 'bg-dark-bg border-white/10 hover:border-white/20'} transition-all duration-300`} data-id="element-229">
              {tier.highlight && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold-500 text-black text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-230">
                  Most Popular
                </div>}

              <div className="mb-8 text-center" data-id="element-231">
                <h3 className={`text-xl font-serif mb-2 ${tier.highlight ? 'text-gold-500' : 'text-white'}`} data-id="element-232">
                  {tier.name}
                </h3>
                <div className="flex items-baseline justify-center text-white" data-id="element-233">
                  <span className="text-3xl font-bold" data-id="element-234">{tier.price}</span>
                  <span className="text-gray-500 text-sm ml-1" data-id="element-235">
                    {tier.period}
                  </span>
                </div>
                <p className="text-gray-400 text-sm mt-4" data-id="element-236">{tier.description}</p>
              </div>

              <ul className="flex-1 space-y-4 mb-8" data-id="element-237">
                {tier.features.map((feature, idx) => <li key={idx} className="flex items-start text-sm text-gray-300" data-id="element-238">
                    <Check className={`w-5 h-5 mr-3 flex-shrink-0 ${tier.highlight ? 'text-gold-500' : 'text-gray-500'}`} data-id="element-239" />
                    <span data-id="element-240">{feature}</span>
                  </li>)}
              </ul>

              <Button variant={tier.highlight ? 'primary' : 'outline'} className="w-full" data-id="element-241">
                {tier.cta}
              </Button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}